/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Bipoc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Bipoc"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#F90"
        d="M20.284 3.756a5.764 5.764 0 0 0-8.284 0l-1.38 1.412 8.284 8.477 1.38-1.413c2.288-2.34 2.288-6.136 0-8.476"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M20.284 3.756a5.764 5.764 0 0 0-8.284 0l-1.38 1.412 8.284 8.477 1.38-1.413c2.288-2.34 2.288-6.136 0-8.476"
      />
      <path
        fill="#F90"
        d="M3.025 15.764c.763.78 2 .78 2.762 0l8.284-8.477-2.761-2.825-8.285 8.476a2.03 2.03 0 0 0 0 2.826"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M3.025 15.764c.763.78 2 .78 2.762 0l8.284-8.477-2.761-2.825-8.285 8.476a2.03 2.03 0 0 0 0 2.826"
      />
      <path
        fill="#F90"
        d="M8.548 21.415c.763.78 2 .78 2.762 0l8.284-8.477-2.761-2.825-8.285 8.476a2.03 2.03 0 0 0 0 2.826"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M8.548 21.415c.763.78 2 .78 2.762 0l8.284-8.477-2.761-2.825-8.285 8.476a2.03 2.03 0 0 0 0 2.826"
      />
      <path
        fill="#F90"
        d="M5.097 19.296c.762.78 1.998.78 2.761 0l8.284-8.477-2.761-2.825-8.284 8.476a2.03 2.03 0 0 0 0 2.826"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M5.097 19.296c.762.78 1.998.78 2.761 0l8.284-8.477-2.761-2.825-8.284 8.476a2.03 2.03 0 0 0 0 2.826"
      />
      <path
        fill="#F90"
        d="M3.716 3.755a5.764 5.764 0 0 1 8.284 0l1.38 1.413-8.284 8.477-1.38-1.413c-2.288-2.34-2.288-6.136 0-8.477"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M3.716 3.755a5.764 5.764 0 0 1 8.284 0l1.38 1.413-8.284 8.477-1.38-1.413c-2.288-2.34-2.288-6.136 0-8.477"
      />
      <path
        fill="#F90"
        d="M20.975 15.764c-.763.78-2 .78-2.762 0L9.93 7.287l2.762-2.825 8.284 8.476a2.03 2.03 0 0 1 0 2.826"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M20.975 15.764c-.763.78-2 .78-2.762 0L9.93 7.287l2.762-2.825 8.284 8.476a2.03 2.03 0 0 1 0 2.826"
      />
      <path
        fill="#F90"
        d="M15.452 21.415c-.763.78-2 .78-2.762 0l-8.284-8.477 2.761-2.825 8.284 8.476a2.03 2.03 0 0 1 0 2.826"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M15.452 21.415c-.763.78-2 .78-2.762 0l-8.284-8.477 2.761-2.825 8.284 8.476a2.03 2.03 0 0 1 0 2.826"
      />
      <path
        fill="#F90"
        d="M18.903 19.296c-.762.78-1.998.78-2.761 0l-8.284-8.477 2.761-2.825 8.284 8.476a2.03 2.03 0 0 1 0 2.826"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M18.903 19.296c-.762.78-1.998.78-2.761 0l-8.284-8.477 2.761-2.825 8.284 8.476a2.03 2.03 0 0 1 0 2.826"
      />
      <path
        fill="#F90"
        d="M7.858 10.82c.762.78 1.999.78 2.762 0l4.142-4.239L12 3.756 7.858 7.994a2.03 2.03 0 0 0 0 2.825"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M7.858 10.82c.762.78 1.999.78 2.762 0l4.142-4.239L12 3.756 7.858 7.994a2.03 2.03 0 0 0 0 2.825"
      />
      <path fill="#F90" d="M16.142 7.994a1.92 1.92 0 0 0-2.761 0l1.38-1.413z" />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M16.142 7.994a1.92 1.92 0 0 0-2.761 0l1.38-1.413z"
      />
    </g>
  </svg>
);

export const BipocIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'bipoc-icon'}
      icon={Bipoc}
      {...props}
      size={size}
    />
  );
};
